import { ServiceRoutesConfig, ServiceRoutesContainer } from './serviceroute.models'

export const serviceRoutesContainer: ServiceRoutesContainer = {
    production: {
        projectWebBaseUrl: 'https://vouchers-ui.villaplus.com/',
        microsoftGraphBaseUrl: 'https://graph.microsoft.com'
    } as ServiceRoutesConfig
} as ServiceRoutesContainer;
